import { useEffect, useState } from "react";
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import styles from "../styles/Educacional.css";
import axios from "axios";
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import { Button, Grid2 } from "@mui/material";
import Agendar from "../Components/Agendar";


const Educacional = () => {
    const [duvidas, setDuvidas] = useState(false)
    const [open, setOpen] = useState(false)
    const [videos, setVideos] = useState([]);

    const fetchVideos = async () => {
        try {
            const response = await axios.get("https://api.sigmasystems.com.br/api/odontoluzzi/videos");
            const data = response.data;

            const loadedVideos = [null, null, null, null, null];
            data.forEach((item) => {
            loadedVideos[item.slot] = item.url 
                ? `https://api.sigmasystems.com.br/api/odontoluzzi${item.url}` 
                : null;
            });

            setVideos(loadedVideos);
        } catch (err) {
            console.error("Erro ao buscar vídeos:", err);
        }
    };
    useEffect(() => {
        fetchVideos();
     }, []);

    useEffect(() => {
    axios.get('https://api.sigmasystems.com.br/api/odontoluzzi/get-duvida')
        .then((response) => {
        const data = response.data;
        setDuvidas(data);
        })
        .catch((error) => {
        console.error('Erro na requisição:', error);
        });
    }, []);

    const handleToggle = (id) => {
        setOpen(open === id ? null : id); 
    };

    return(
        <div className="container">
            <Header/>
            <div className="content">
                <div className="eduContainer">
                    <div className="eduContent">
                        <div className="subTitle from-top">Dicas</div>
                        <div className="title depo from-top">Dicas e vídeos educacionais</div>
                        <div className="titleLine from-top"/>
                        <div className="grid-faq from-bottom">
                            {duvidas ?  <>
                                {duvidas.map((item) => (
                                    <div key={item.id} className="faq-item">
                                        <div className={`question ${open === item.id ? "open":""}`} onClick={() => handleToggle(item.id)}>
                                            <div className="question-title">{item.titulo}</div>
                                            <div className={`icon-container ${open === item.id ? "open" : ""}`}>
                                            <ExpandMoreRoundedIcon sx={{ fontSize: 32, color:'#fff' }} />
                                            </div>
                                        </div>

                                        <div className={`answer ${open === item.id ? "open" : ""}`}>
                                            <div className="answer-text">{item.resposta}</div>
                                        </div>
                                    </div>
                                ))}
                            </>: ""}
                        </div>
                        

                                    
                    </div>
                </div>
                <div className="eduFeedContainer">
                    <div className="eduFeedContent from-bottom">
                        <div className="subTitle" style={{color:'#fff'}}>Educacionais</div>
                        <div className="title">Vídeos educacionais</div>
                        <div className="titleLine" style={{backgroundColor:'#fff'}}/>
                        <Grid2 container justifyContent={'center'} spacing={1} sx={{ marginTop: 9 }} className='from-bottom' style={{ transitionDelay: '0.2s' }}>
                            {videos.map((video, index) => 
                                video ? ( 
                                <Grid2
                                    item
                                    key={index}
                                    xs={12}
                                    sm={6}
                                    md={4}
                                    lg={2.4}
                                    sx={{
                                    cursor: "pointer",
                                    borderRadius: "5px",
                                    width: 240,
                                    height: 300,
                                    alignContent: "center",
                                    textAlign: "center",
                                    }}
                                >
                                    <video
                                    src={video}
                                    muted
                                    controls
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        borderRadius: "5px",
                                    }}
                                    />
                                </Grid2>
                                ) : null
                            )}
                        </Grid2>
                        <a href='https://instagram.com/odontoluzzi' style={{marginTop:'30px'}}>
                        <Button sx={{color:'#fff', height:50, width:162, borderRadius:'5px', border:'solid 2px #fff', fontSize:'15px', fontWeight:'bold', backgroundColor:'none', textTransform: 'none','&:hover': {color: '#B08E44', backgroundColor:'#fff'}}}>Ver mais</Button>
                        </a>
                        
                    </div>
                </div>
                <Agendar/>
            </div>
            <Footer/>
        </div>
    )
}
export default Educacional;